import { IAgendamentoDTO } from "../types/agendamento";

/**
 * Whether the agendamento is a "primeiro emplacamento": the vehicle has no
 * plate yet (empty/null `veiculo.placa`), so the details view shows the chassi
 * instead of plate/renavam.
 */
export function isPrimeiroEmplacamento(agendamento?: IAgendamentoDTO) {
  return !agendamento?.veiculo?.placa?.trim();
}
